<template>
  <vs-prompt
    class="vs-modal"
    v-bind="$props"
    @cancel="onCancel"
    @accept="onAccept"
    @close="onClose"
    :active="active"
    :parent="parent"
  >
    <slot></slot>
  </vs-prompt>
</template>

<script>
export default {
  name: "modal-wrapper",
  props: {
    color: {
      default: "primary",
      type: String
    },
    title: {
      default: "弹框",
      type: String
    },
    buttonAccept: {
      default: "filled",
      type: String
    },
    buttonCancel: {
      default: "flat",
      type: String
    },
    isValid: {
      default: "none",
      type: [Boolean, String]
    },
    buttonsHidden: {
      default: false,
      type: Boolean
    },
    acceptText: {
      default: "确定",
      type: String
    },
    cancelText: {
      default: "取消",
      type: String
    },
    iconPack: {
      default: "material-icons",
      type: String
    },
    closeIcon: {
      default: "close",
      type: String
    },
    cancel: {
      default: () => {},
      type: Function
    },
    accept: {
      default: () => {},
      type: Function
    },
    width: {
      type: [String, Number],
      default: '95vw'
    }
  },
  data() {
    return { active: true };
  },
  watch: {
    active(n) {
      if (!n) {
        this.$modalClose(this.modalid);
        this.$emit("close");
      }
    }
  },
  computed: {
    modalid() {
      return this.$parent.id;
    },
    parent() {
      // return this.$parent.$el
      return document.getElementById('modal-container')
    }
  },
  methods: {
    onClose() {
      return this.onCancel();
    },
    async onAccept() {
      const rt = await this.accept();
      if (rt !== false) {
        this.active = false;
      }
    },
    async onCancel() {
      const rt = await this.cancel();
      if (rt !== false) {
        this.active = false;
      }
    }
  }
};
</script>